import {API_URLS} from '@px/const/urls';
import {http} from '@px/helper/http';

export const lendingApi = {
  getAssets(query?: Record<string, any>) {
    return http.get(API_URLS.LENDING_ASSETS_OVERVIEW, {query});
  },
  getPool(query?: Record<string, any>) {
    return http.get(API_URLS.LENDING_POOL, {query});
  },
  getPublicPool(query?: Record<string, any>) {
    return http.get(API_URLS.LENDING_PUBLIC_DATA_POOL, {query});
  },
};
